// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".devices-warp[data-v-5866bbc5]{height:calc(100% - 60px);overflow-x:hidden;overflow-y:scroll}.devices-warp .device-warp .device-title[data-v-5866bbc5]{font-weight:700;position:relative}.devices-warp .device-warp .device-title .extra[data-v-5866bbc5]{position:absolute;right:5px;top:0}.devices-warp .device-warp .device-content[data-v-5866bbc5]{display:flex;justify-content:space-between;align-items:center;height:30px}", ""]);
// Exports
module.exports = exports;
